import { createReducer, MetaReducer, on } from '@ngrx/store';
import { clearError, requestFailure } from '../error/error.actions';
import { reset } from '../quote-controller/quote-controller.actions';

export const errorFeatureKey = 'error';

export interface ErrorState {
    error?: any;
}

export const initialState: ErrorState = {};

export const reducers = createReducer(
    initialState,
    on(requestFailure, (state, error) => {
        // Check if the error is from a cancelled request
        if (
            error?.name === 'AbortError' ||
            error?.status === 0 ||
            error?.message?.includes('cancelled')
        ) {
            console.warn('Request cancelled or aborted, not updating state:', error);
            return state; // Don't update state for cancelled requests
        }
        return { ...state, error };
    }),
    on(clearError, () => {
        return initialState;
    }),
    on(reset, () => {
        return initialState;
    }),
);

export const metaReducers: MetaReducer<ErrorState>[] = [];
